const THEME_THUMBNAILS = [
  {
    id: "default",
    label: "Default",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/default.png",
    data: {
      background: "#fff",
      colorTransparency: 0.0,
      backgroundImage: "",
      imageTransparency: 0.1,
      imagePosition: "center right",
      appliedTheme: "Default",
    },
  },
  {
    id: "juniper",
    label: "Juniper",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_juniper.jpg",
    data: {
      background: "#184651",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 0.9,
      imagePosition: "center right",
      appliedTheme: "Juniper",
    },
  },
  {
    id: "lilac",
    label: "Lilac",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_lilac.jpg",
    data: {
      background: "#5a3d68",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-laptop.jpg",
      imageTransparency: 1.0,
      imagePosition: "center right",
      appliedTheme: "Lilac",
    },
  },
  {
    id: "canary",
    label: "Canary",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_canary.jpg",
    data: {
      background: "#1cb5c0",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1,
      imagePosition: "top center",
      appliedTheme: "Canary",
    },
  },
  {
    id: "celestial",
    label: "Celestial",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_celestial.jpg",
    data: {
      background: "#37bc72",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-shapes.jpg",
      imageTransparency: 1.0,
      imagePosition: "center right",
      appliedTheme: "Celestial",
    },
  },
  {
    id: "allure",
    label: "Allure",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_allure.jpg",
    data: {
      background: "#35304B",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-abstract.jpg",
      imageTransparency: 1.0,
      imagePosition: "center right",
      appliedTheme: "Allure",
    },
  },
  {
    id: "scarlet",
    label: "Scarlet",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_scarlet.jpg",
    data: {
      background: "#00aab5",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-abstract.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Scarlet",
      imagePosition: "center right",
    },
  },
  {
    id: "fuschia",
    label: "Fuschia",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_fuschia.jpg",
    data: {
      background: "#e3e1e0",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-shapes.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Fuschia",
      imagePosition: "center right",
    },
  },
  {
    id: "titian",
    label: "Titian",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_titian.jpg",
    data: {
      background: "#202761",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-shapes.jpg",
      imageTransparency: 1,
      appliedTheme: "Titian",
      imagePosition: "center center",
    },
  },
  {
    id: "smokey",
    label: "Smokey",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_smokey.jpg",
    data: {
      background: "#f9581e",
      colorTransparency: 0.6,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Smokey",
      imagePosition: "center right",
    },
  },
  {
    id: "mellow",
    label: "Mellow",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_mellow.jpg",
    data: {
      background: "#081623",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 0.8,
      appliedTheme: "Mellow",
      imagePosition: "center right",
    },
  },
  {
    id: "cerulean",
    label: "Cerulean",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_cerulean.jpg",
    data: {
      background: "#5a3d68",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Cerulean",
      imagePosition: "center right",
    },
  },
  {
    id: "buttery",
    label: "Buttery",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_buttery.jpg",
    data: {
      background: "#0014c6",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-laptop.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Buttery",
      imagePosition: "center right",
    },
  },
  {
    id: "perfection",
    label: "Perfection",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_perfection.jpg",
    data: {
      background: "#ffef64",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-abstract.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Perfection",
      imagePosition: "center right",
    },
  },
  {
    id: "mahogany",
    label: "Mahogany",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_mahogany.jpg",
    data: {
      background: "#ac2102",
      colorTransparency: 1,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-abstract.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Mahogany",
      imagePosition: "center center",
    },
  },
  {
    id: "youth",
    label: "Youth",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_youth.jpg",
    data: {
      background: "#9dbb24",
      colorTransparency: 0.6,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Youth",
      imagePosition: "center right",
    },
  },
  {
    id: "lush",
    label: "Lush",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_lush.jpg",
    data: {
      background: "#346d06",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 0.8,
      appliedTheme: "Lush",
      imagePosition: "center right",
    },
  },
  {
    id: "ether",
    label: "Ether",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_ether.jpg",
    data: {
      background: "#bbd2ff",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Ether",
      imagePosition: "top right",
    },
  },
  {
    id: "glow",
    label: "Glow",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_glow.jpg",
    data: {
      background: "#e1b0b0",
      colorTransparency: 1.0,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-street.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Glow",
      imagePosition: "center right",
    },
  },
  {
    id: "olive",
    label: "Olive",
    thumbnail:
      "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page/thumbnail_olive.jpg",
    data: {
      background: "#647b69",
      colorTransparency: 0.8,
      backgroundImage:
        "https://s3.amazonaws.com/webcontent.revv.so/images/cover-page-image-template-shapes.jpg",
      imageTransparency: 1.0,
      appliedTheme: "Olive",
      imagePosition: "center right",
    },
  },
];

// eslint-disable-next-line import/prefer-default-export
export { THEME_THUMBNAILS };
